module.exports = __webpack_public_path__ + "static/media/Mar12-S18.17c8aa5e.png";